import {Pipe, PipeTransform} from "@angular/core";
import * as moment from "moment";

@Pipe({name: 'mydate'})
export class MydatePipe implements PipeTransform {
  transform(value: Date, format: string): any {
    return moment(value).format(format);
    //return `${value.getFullYear()}-${value.getMonth() < 9 ? '0' : ''}${value.getMonth() + 1}-${value.getDate() < 10 ? '0' : ''}${value.getDate()}`;
  }
}

@Pipe({name: 'HHMM'})
export class HHMMPipe implements PipeTransform {
  transform(value: string): any {
    return moment(value, 'HHmm').format('HH:mm');
  }
}


// WEBPACK FOOTER //
// ./src/app/pipe/mydate.pipe.ts